import i18n, { languageToLocale } from '@/lib/i18n';

export function getPreferredLocaleHeader(): string {
  return languageToLocale(i18n.resolvedLanguage ?? i18n.language ?? 'en');
}
